module.exports = __webpack_public_path__ + "img/users-gear.a8a17424.svg";